<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1"><a id="_idTextAnchor000"></a>The Sleep of Baby Filbertson</p>
<p class="ORIM-Book-Subtitle--Front-Matter-"><span class="CharOverride-2">And other stories</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><span class="CharOverride-2">James Leo Herlihy</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Baby_F_epub16.vue?798fc974